import { apiRequest } from "../../services/apiService";
import {
    GET_SURVEY_GROUPS_REQUEST,
    GET_SURVEY_GROUPS_SUCCESS,
    GET_SURVEY_GROUPS_FAIL,
    GET_SURVEY_GROUP_DETAIL_REQUEST,
    GET_SURVEY_GROUP_DETAIL_SUCCESS,
    GET_SURVEY_GROUP_DETAIL_FAIL,
    CREATE_SURVEY_GROUP_REQUEST,
    CREATE_SURVEY_GROUP_SUCCESS,
    CREATE_SURVEY_GROUP_FAIL,
    UPDATE_SURVEY_GROUP_REQUEST,
    UPDATE_SURVEY_GROUP_SUCCESS,
    UPDATE_SURVEY_GROUP_FAIL,
    DELETE_SURVEY_GROUP_REQUEST,
    DELETE_SURVEY_GROUP_SUCCESS,
    DELETE_SURVEY_GROUP_FAIL
} from "../constant";

// Get all survey groups
export const getSurveyGroups = () => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_GROUPS_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getSurveyGroups`
        });
        if (response) {
            dispatch({ type: GET_SURVEY_GROUPS_SUCCESS, payload: response?.data });
        } else if (error) {
            dispatch({ type: GET_SURVEY_GROUPS_FAIL });
        }
    };
};

// Get survey group detail (group metadata + items/surveys)
export const getSurveyGroupDetail = (groupId) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_GROUP_DETAIL_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getSurveyGroupDetail?group_id=${groupId}`
        });
        if (response) {
            dispatch({ type: GET_SURVEY_GROUP_DETAIL_SUCCESS, payload: response?.data });
        } else if (error) {
            dispatch({ type: GET_SURVEY_GROUP_DETAIL_FAIL });
        }
    };
};

// Create survey group
export const createSurveyGroup = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_SURVEY_GROUP_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/createSurveyGroup`,
            data: data,
            showErrorToast: false
        });
        if (response) {
            dispatch({ type: CREATE_SURVEY_GROUP_SUCCESS, payload: response?.data });
            if (successCallback) successCallback(response?.data);
        } else if (error) {
            dispatch({ type: CREATE_SURVEY_GROUP_FAIL });
            if (failCallback) failCallback(error);
        }
    };
};

// Update survey group (rename)
export const updateSurveyGroup = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SURVEY_GROUP_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updateSurveyGroup`,
            data: data,
            showErrorToast: false
        });
        if (response) {
            dispatch({ type: UPDATE_SURVEY_GROUP_SUCCESS, payload: response?.data });
            if (successCallback) successCallback(response?.data);
        } else if (error) {
            dispatch({ type: UPDATE_SURVEY_GROUP_FAIL });
            if (failCallback) failCallback(error);
        }
    };
};

// Delete survey group
export const deleteSurveyGroup = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_SURVEY_GROUP_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/deleteSurveyGroup`,
            data: data,
            showErrorToast: false
        });
        if (response) {
            dispatch({ type: DELETE_SURVEY_GROUP_SUCCESS, payload: response?.data });
            if (successCallback) successCallback(response?.data);
        } else if (error) {
            dispatch({ type: DELETE_SURVEY_GROUP_FAIL });
            if (failCallback) failCallback(error);
        }
    };
};

// Update survey group items (e.g., set primary, reorder)
export const updateSurveyGroupItems = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updateSurveyGroupItems`,
            data: data,
            showErrorToast: false
        });
        if (response) {
            if (successCallback) successCallback(response?.data);
        } else if (error) {
            if (failCallback) failCallback(error);
        }
    };
};

// Remove survey from group
export const removeSurveyFromGroup = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/removeSurveyFromGroup`,
            data: data,
            showErrorToast: false
        });
        if (response) {
            if (successCallback) successCallback(response?.data);
        } else if (error) {
            if (failCallback) failCallback(error);
        }
    };
};

// Add survey to group
export const addSurveyToGroup = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/addSurveyToGroup`,
            data: data,
            showErrorToast: false
        });
        if (response) {
            if (successCallback) successCallback(response?.data);
        } else if (error) {
            if (failCallback) failCallback(error);
        }
    };
};

